(function () {
  var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  if (connection) {
    if (connection.saveData) return;
    if (connection.effectiveType === 'slow-2g' || connection.effectiveType === '2g') return;
  }

  var queued = {};

  function productKey(href) {
    try {
      var url = new URL(href, location.href);
      if (url.origin !== location.origin) return '';
      if (url.pathname.indexOf('/products/') !== 0) return '';
      return url.pathname;
    } catch (error) {
      return '';
    }
  }

  function prefetch(href) {
    var key = productKey(href);
    if (!key || queued[key]) return;
    if (key === location.pathname) return;
    queued[key] = true;

    var absolute = new URL(href, location.href).href;
    var link = document.createElement('link');
    link.rel = 'prefetch';
    link.as = 'document';
    link.href = absolute;
    document.head.appendChild(link);
  }

  function productHrefs() {
    var nodes = document.querySelectorAll('a[href*="/products/"]');
    var hrefs = [];
    var seen = {};
    for (var i = 0; i < nodes.length; i++) {
      var key = productKey(nodes[i].href);
      if (!key || seen[key] || key === location.pathname) continue;
      seen[key] = true;
      hrefs.push(nodes[i].href);
      if (hrefs.length >= 6) break;
    }
    return hrefs;
  }

  function idlePrefetch() {
    var hrefs = productHrefs();
    for (var i = 0; i < hrefs.length; i++) prefetch(hrefs[i]);

    if (!(HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules'))) return;
    if (!hrefs.length) return;

    var script = document.createElement('script');
    script.type = 'speculationrules';
    script.textContent = JSON.stringify({
      prefetch: [
        {
          source: 'list',
          urls: hrefs.map(function (href) {
            return new URL(href, location.href).href;
          }),
          eagerness: 'moderate'
        }
      ]
    });
    document.head.appendChild(script);
  }

  document.addEventListener(
    'pointerenter',
    function (event) {
      var link = event.target && event.target.closest && event.target.closest('a[href*="/products/"]');
      if (link) prefetch(link.href);
    },
    true
  );

  function start() {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(idlePrefetch, { timeout: 2500 });
    } else {
      window.setTimeout(idlePrefetch, 800);
    }
  }

  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start);
})();
